import { CloseCircleMultipleIcon } from './CloseCircleMultipleIcon';

/**
 * author: Michael Irigoyen
 * id 77B97AED-2613-434C-BD9C-82755C8B468C
 * name close-circle-multiple
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-circle-multiple.svg
 * tags
 * - Form 
 */
export const RemoveCircleMultipleIcon = CloseCircleMultipleIcon;
export default RemoveCircleMultipleIcon